document.addEventListener("DOMContentLoaded", function(){
  var alltabs = document.querySelectorAll(".tab__btn--pdp");
  alltabs.forEach(function(ele){
    ele.addEventListener("click", function(){
      var allt = document.querySelectorAll(".tab__btn--pdp");
      allt.forEach(function(ele){
        ele.classList.remove("active");
      });
      ele.classList.add("active");

      var attributename = ele.getAttribute("data-name");
      var allcontents = document.querySelectorAll(".tabs__content--innerdes");
      allcontents.forEach(function(ele){
        ele.classList.remove("active");
      });

      var contentmain = document.querySelector(`[data-namem="${attributename}"]`);
      console.log(contentmain)
      if (contentmain){
        contentmain.classList.add("active");
      }
    });
  });
});
